import React, { useState, useEffect, Children } from "react";
import { EmployeeDataVM, EmployeeTeamVM, PKTVM } from '../../Models/ViewModels';
import { Table, Pagination, Stack, Avatar, Input, Button, DatePicker } from "rsuite";
import * as ProfileDB from '../../Services/KRAApprovalDB';
import { PageHeader } from "../../SharedComponents/PageHeader";

import { handleDownloadAsExcel } from "../../Helpers/Utils";
import { GetUserLoginID } from "../../Services/UserSessionManager";
import { CustomTableCell } from '../../SharedComponents/CustomTableCell';
import { CustomTableHeaderCell } from '../../SharedComponents/CustomTableHeaderCell';
import { BootstrapIcon } from "../../SharedComponents/BootstrapIcon";
import { GetLocationDetails } from "../../Services/EmployeeDB";

const { Column, HeaderCell, Cell } = Table;
const colors = ['pink', 'grey', 'blue', 'yellow', 'purple', 'green', 'red'];

export const ApplicationSearch = ({ name, designation, department }: any) => {

  const [cachedEmployeesList, setCachedEmployeesList] = useState(new Array<PKTVM>())
  const [sortColumn, setSortColumn] = useState();
  const [isLoading, setLoading] = useState(true)
  const [sortType, setSortType] = useState();
  const [page, setPage] = React.useState(1);
  const [date, setDate] = useState();

  const [limit, setLimit] = React.useState(15);
  const [filteredEmployeesList, setFilteredEmployeesList] = useState(new Array<PKTVM>());
  const[loginid,setLoginid]=useState(GetUserLoginID())
  const[searching,setSearching]=useState(false);

  useEffect(() => {
    getAllEmployeesPKT(loginid);
  },[])


const handleSet=(value:any)=>{
   alert("Button Clicked")
}

  const tableDataFeed = filteredEmployeesList.filter((v, i) => {
    const start =limit * (page - 1);
    const end = start + limit;
    return i >= start && i < end;
  });

  const handleChangeLimit = (dataKey: any) => {
    setPage(1);
    setLimit(dataKey);
  };

  const getAllEmployeesPKT = (loginid:any) => {
  GetLocationDetails(loginid).then((res : EmployeeTeamVM[] | any) => {
      if (res.data) {
        setCachedEmployeesList(res.data)
        setFilteredEmployeesList(res.data);
        setLoading(false);
      };
    }).catch(err => {
      console.log("fail")
    })
  }
  
  const handleFilterData = (val: string, e: any) => {
    let searchText = val;
 
    setPage(1);
    if (searchText){
      setFilteredEmployeesList(cachedEmployeesList.filter(e => JSON.stringify(e).toLowerCase().includes(searchText.toLowerCase())))
    } 

    else{                                
      setFilteredEmployeesList([...cachedEmployeesList]);
    }
  }


  const handleSortColumn = (sortColumn: any, sortType: any) => {

    setLoading(true);
    setTimeout(() => {
      setLoading(false);
      setSortColumn(sortColumn);
      setSortType(sortType);
    }, 500);

    if (sortColumn && sortType) {
      return filteredEmployeesList.sort((a: any, b: any) => {
        let x = a[sortColumn];
        let y = b[sortColumn];
        if (typeof x === 'string' || '') {
          x = x.charCodeAt();
        }
        if (typeof y === 'string' || '') {
          y = y.charCodeAt();
        }
        if (sortType === 'asc') {
          return x - y;
        } else {
          return y - x;
        }
      });
    }
  };

  return <>
   
  <div className="row">
  <div className="col-md-7">
  <PageHeader title="My Apps" backPage="" ><></></PageHeader>
    </div>
  
    <hr />
</div>
    

    <div className="show-container" bg-color="pink" >
     
      <Table
        id="table"
        data={tableDataFeed}
        loading={isLoading}
        height={450}
        sortColumn={sortColumn}
        sortType={sortType}
        onSortColumn={handleSortColumn}
        bordered={true}
        cellBordered={true}
        className="border border-dark mt-2"
        autoHeight={true}
        rowHeight={30}
        headerHeight={30}
      >
    

        <Column align="center"flexGrow={230} sortable>
          <CustomTableHeaderCell>
            Applications
          </CustomTableHeaderCell>
          <CustomTableCell dataKey=""  />
        </Column>

        <Column flexGrow={200} align="center"sortable>
          <CustomTableHeaderCell>URL</CustomTableHeaderCell>
          <CustomTableCell dataKey=""/>
        </Column>

        <Column flexGrow={180} align="center" >
          <CustomTableHeaderCell></CustomTableHeaderCell>
          <CustomTableCell><button onClick={handleSet}>Click here to Login</button></CustomTableCell>
        </Column>

     </Table>

        </div>
  </>
}